import { render, staticRenderFns } from "./PlatformAddUpdate.vue?vue&type=template&id=5961cc82"
import script from "./PlatformAddUpdate.vue?vue&type=script&lang=js"
export * from "./PlatformAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports